
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'


const HISTORY_KEY = 'word_search_history'
const MAX_HISTORY = 20

export default {
directives: {
TransferDom
},
components: {
Group,
Cell,
Confirm
},
data () {
return {
results: [],
value: '',
show2: false,
historys: [],
wsongUrl: '',
searchSeq: 0,
audio: {
currentTime: 0,
maxTime: 0,
playing: false,
muted: false,
speed: 1,
waiting: true,
preload: 'auto'
},
confirmShow: false,
controlList: {
noDownload: true,
noMuted: true,
noVolume: false,
noProcess: false,
onlyOnePlaying: false,
noSpeed: true
}
}
},
created () {
this.getHistory()
const keyword = this.$route.query.keyword
if (keyword && String(keyword).trim()) {
this.value = String(keyword).trim()
this.getResult(this.value)
}
},
mounted () {
this.$nextTick(() => {
this.focusSearchInput()
})
},
methods: {
focusSearchInput () {
const searchRef = this.$refs.search
if (!searchRef) return
const root = searchRef.$el || searchRef
const input = root.querySelector && root.querySelector('input')
if (input) {
input.focus({ preventScroll: true })
}
},
showDetail (english, chinese, navWord) {
this.saveHistory(english, chinese)
this.$router.push({
path: '/indexSelect_display',
query: { word: navWord !== undefined ? navWord : chinese }
})
},
getResult (val) {
const keyword = (val != null ? val : this.value).replace(/\s*/g, '')
if (keyword === '') {
this.show2 = false
this.results = []
return
}

const seq = ++this.searchSeq
this.$ajax
.get(this.$api.messageMessageBoardgetByWord + '?word=' + encodeURIComponent(keyword))
.then(response => {
if (seq !== this.searchSeq) return
if (
!response ||
response.length <= 0 ||
this.value.replace(/\s*/g, '') === '' ||
keyword === ''
) {
this.results = []
this.show2 = false
this.$vux.toast.text('未查询到相关单词！')
return
}
this.results = response
this.show2 = true
})
.catch(() => {
if (seq !== this.searchSeq) return
this.$vux.loading.hide()
})
},
onCancel () {
this.$router.push({ path: '/home?hideTrans=true' })
},
onClear () {
this.show2 = false
this.results = []
this.searchSeq++
},
getHistory () {
try {
const raw = localStorage.getItem(HISTORY_KEY)
this.historys = raw ? JSON.parse(raw) : []
} catch (e) {
this.historys = []
}
},
persistHistory () {
localStorage.setItem(HISTORY_KEY, JSON.stringify(this.historys))
},
saveHistory (english, chinese) {
if (!english || typeof english !== 'string') return
const list = this.historys.filter(item => item.english !== english)
list.unshift({
english,
chinese: chinese || '',
createtime: Date.now()
})
this.historys = list.slice(0, MAX_HISTORY)
this.persistHistory()
},
clearHistory () {
this.confirmShow = true
},
onConfirm () {
this.historys = []
localStorage.removeItem(HISTORY_KEY)
},
playAudio (suffix, english) {
const value = english.toLowerCase()
this.wsongUrl = $.serverInfo.videopath + value + suffix
const audioEl = this.$refs.waudio
if (!audioEl) return
audioEl.src = this.wsongUrl
setTimeout(() => {
audioEl.play()
}, 500)
},
playA (english) {
this.playAudio('_b.mp3', english)
},
playB (english) {
this.playAudio('_a.mp3', english)
},
onPlay (res) {
this.audio.playing = true
this.audio.loading = false
if (!this.controlList.onlyOnePlaying) return
const target = res.target
const audios = document.getElementsByTagName('audio')
;[...audios].forEach(item => {
if (item !== target) {
item.pause()
}
})
},
onError () {
this.audio.waiting = true
},
onWaiting () {},
onTimeupdate (res) {
this.audio.currentTime = res.target.currentTime
},
onLoadedmetadata (res) {
this.audio.waiting = false
this.audio.maxTime = parseInt(res.target.duration)
}
}
}



// WEBPACK FOOTER //
// ./src/views/word/WordSearch.vue